/* eslint-disable radix */
/* eslint-disable no-restricted-globals */
import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";
import { ClientId, DivisionId, SenderId,PrevilageId } from '../../helper/HelperAuth'
import UploadFile from '../../store/action/UploadMediaId/Upload'
import ComboboxInput from '../../infra/components/formInput/ComboboxInput'
import ActionFetchAllClient from '../../store/action/Client/FetchAll'
import ActionFetchAllDivision from '../../store/action/Division/FetchAll'
import ActionFetchSender from '../../store/action/Sender/FetchAll'
import ActionGetAccessModule from '../../store/action/AccessModule/Fetch'
import Swal from 'sweetalert2'
import './style.css'

class Form extends Component {

  constructor(props) {
    super(props);
    this.state = {
      params: fromJS({}),
      form: fromJS({
        "selected-file": [],
        "upload-completed": false,
        "client-id": null,
        "division-id": null,
        "sender-id": '',
        "sender-name": '',
        "file-name": '',
      }),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
      actionId: '',
      disabledHead: false,
      disrest: true,
      filetype: "",
      // bulk upload
      files: fromJS([]),
      uploading: false,
      preparing: false, // Flag to track if preparing for upload
      currentUploadIndex: -1, // Track which file is currently being uploaded
    };

    this.fileInputRefs = Array(10)
      .fill()
      .map(() => React.createRef());

    this.handleChange = this.handleChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleOnFileChanged = this.handleOnFileChanged.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);
    this.handleCancelFile = this.handleCancelFile.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.initializeFileRows = this.initializeFileRows.bind(this)
    this.uploadNextFile = this.uploadNextFile.bind(this)
    this.handleUploadSingleFile = this.handleUploadSingleFile.bind(this)
    this.handleRetryUpload = this.handleRetryUpload.bind(this)
    this.handleChooseFile = this.handleChooseFile.bind(this)
    this.simulateFileUpload = this.simulateFileUpload.bind(this)
  }

  async componentDidMount() {
    this.initializeFileRows();
    let formVal = this.state.form
    await this.props.actionGetAccessModule(PrevilageId);
    this.props.actionFetchAllClient()
    let restrict = this.handleActionId()
    if (restrict == 5) {
      await this.props.actionFetchAllDivision(ClientId, 'Upload Media Id')
      this.props.actionFetchSender(ClientId)
      formVal = formVal.set("client-id", ClientId)
      formVal = formVal.set("division-id", DivisionId)
      formVal = formVal.set("sender-id", SenderId)
      this.setState({
        form: formVal,
        disrest: true,
        actionId: restrict
      })
    }else{
      this.setState({
        disrest: false
      })
    }

  }
  async handleSubmit() {
    const form = this.state.form;
    var file = this.state.form.get('selected-file');
    var varClientId = this.state.form.get('client-id');
    var varDivisionId = this.state.form.get('division-id');
    var varSenderId = this.state.form.get('sender-id');
    var varSenderWord = this.state.form.get('sender-name');

    if (form.get("client-id") === '' || form.get("client-id") === null || form.get("client-id") === undefined) {
      toast.error('Client cannot be empty!', toast.POSITION.TOP_RIGHT);
      return false
    }
    if (form.get("division-id") === '' || form.get("division-id") === null || form.get("division-id") === undefined) {
      toast.error('Division cannot be empty!', toast.POSITION.TOP_RIGHT);
      return false
    }
    if (form.get("sender-id") === '' || form.get("sender-id") === null || form.get("sender-id") === undefined) {
      toast.error('Sender cannot be empty!', toast.POSITION.TOP_RIGHT);
      return false
    }
    if (form.get("file-name") === '' || form.get("file-name") === null || form.get("file-name") === undefined) {
      toast.error('Upload file first', toast.POSITION.TOP_RIGHT);
      return false
    }
    var response = await this.props.actionUploadFile(file, varClientId, varDivisionId, varSenderId, varSenderWord);
    if (response.ok) {
      toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
      this.props.handleCancelForm(true);
    } else {
      toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
    }
  }
  handleActionId() {
    let array = []
    let action = 0;
    let menuPrev = (this.props.accessmodules.get('data') != null ? this.props.accessmodules.get('data') : fromJS([]));
    {
      menuPrev.map((data, i) =>
        array.push({
          'menu-name': data.get('menu-name'),
          'action-id': data.get('action-id')
        })

      )
    }

    for (let i = 0; i < array.length; i++) {
      if (array[i]['menu-name'] === 'Upload Media Id') {
        action = array[i]['action-id'];
        this.state.action_id = array[i]['action-id'];
      }
    }
    return action;
  }

  handleCancelFile() {
    var changeVals = this.state.form;
    var statDis = true;
    var actionIdVar = this.state.actionId;

    if (actionIdVar != 5) {
      changeVals = changeVals.set('client-id', null).set('sender-id', null).set('division-id', null).set('sender-word', null)
      statDis = false;
    }
    changeVals = changeVals.set('file-name', '');
    changeVals = changeVals.set('selected-file', null);
    changeVals = changeVals.set('upload-completed', false);

    this.setState({ form: changeVals, disabled: false, disabledHead: statDis })
  }

  handleChooseFile(index) {
    const fileInput = this.fileInputRefs[index]
    if (fileInput && fileInput.current) {
      fileInput.current.click()
    }
  }

  handleChange(field, value, label) {
    var formVal = this.state.form;
    formVal = formVal.set(field, value);

    if (field === "client-id") {
      this.props.actionFetchAllDivision(value);
      this.props.actionFetchSender(value);
      if (value === '' || value === undefined || value === null) {
        formVal = formVal.set(field, value).set('sender-id', null).set('division-id', null)
      } else {
        formVal = formVal.set(field, value)
      }
    }

    if (field === "division-id") {
      if (value === '' || value === undefined || value === null) {
        formVal = formVal.set(field, value).set('sender-id', null)
        //this.props.actionFetchSender(this.state.form.get('client-id'), 'false');
      } else {
       // this.props.actionFetchSender(this.state.form.get('client-id'), value);
      }
    }
    if (field === "sender-id") {
      formVal = formVal.set(field, value).set('sender-name', label)
    }
    this.setState({ form: formVal })
  }



  async handleUploadFile() {
    var file = this.state.files.toJS();
    var varClientId = this.state.form.get('client-id');
    var varDivisionId = this.state.form.get('division-id');
    var varSenderId = this.state.form.get('sender-id');
    var varSenderWord = this.state.form.get('sender-name');
    // if(this.state.filetype !== "text"){
    //   toast.error('Only accepted file with extension .txt', toast.POSITION.TOP_RIGHT);
    //   return false
    // }
    // if (varClientId && varDivisionId && varSenderId && file) {
      Swal.fire({
        title: 'Do you want upload this file',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `No`,
      }).then((result) => {
        if (result.isConfirmed) {
          const namefile = file.filter(f => f.name.trim() !== '').length;
          if (namefile == 1) {
            this.senddata()
          } else {
            this.uploadNextFile()
          }
          
        } else if (result.isDenied) {
          Swal.fire('Changes are not saved', '', 'info')
          confirm = false
          return false
        }
      })
    // } else {
    //   toast.error('Client, Division, Sender and file must be filled', toast.POSITION.TOP_RIGHT);
    // }
  }

  async senddata() {
    const files = this.state.files.toJS();
    var file = files.find(file => file.selected).file;
    var varClientId = this.state.form.get('client-id');
    var varDivisionId = this.state.form.get('division-id');
    var varSenderId = this.state.form.get('sender-id');
    var varSenderWord = this.state.form.get('sender-name');
    var filetype = this.state.filetype
    var response = await this.props.actionUploadFile(file, varClientId, varDivisionId, varSenderId, varSenderWord,filetype);
    if (response.get('success')) {
      let newForm = this.state.form;
      newForm = newForm.set('file-name', response.get('file-name'));
      newForm = newForm.set('upload-completed', true);
      this.setState({
        form: newForm,
        disabled: true,
        disabledHead: true
      })
      toast.success('Upload Success', toast.POSITION.TOP_RIGHT);
      this.handleCancel()
    } else {
      toast.error('Upload Failed!', toast.POSITION.TOP_RIGHT);
    }
  }
  handleCancel() {
    this.props.handleCancelForm(true);
  }

  handleOnFileChanged(e, index) {
    // let newForm = this.state.form;
    // newForm = newForm.set("selected-file", event.target.files[0]);
    // let type = event.target.files[0].type
    // this.setState({
    //   form: newForm,
    //   filetype:type
    // })
    if (e.target.files && e.target.files.length > 0) {
      const newFile = e.target.files[0];

      const files = this.state.files.toJS();
      files[index] = {
        ...files[index],
        name: newFile.name,
        type: newFile.type,
        file: newFile,
        selected: true,
        status: "selected",
        progress: 0
      }
      
      this.setState({
        files: fromJS(files),
      });
    }
  }

  initializeFileRows() {
    // Create 10 empty file slots
    const emptyFiles = Array(10)
      .fill()
      .map((_, index) => ({
        id: `file-${index}`,
        name: "",
        type: "",
        file: null,
        selected: false,
        status: "empty",
        progress: 0,
        index,
      }))

    this.setState({ files: fromJS(emptyFiles) })
  }

  // Simulate uploading a single file with progress updates
  async simulateFileUpload(fileId, shouldFail = false) {
    try {
      const files = this.state.files.toJS()
      const fileIndex = files.findIndex((f) => f.id === fileId)

      if (fileIndex === -1 || !files[fileIndex].file) {
        throw new Error("File not found")
      }

      const file = files[fileIndex].file
      var varClientId = this.state.form.get('client-id');
      var varDivisionId = this.state.form.get('division-id');
      var varSenderId = this.state.form.get('sender-id');
      var varSenderWord = this.state.form.get('sender-name');
      var filetype = this.state.filetype

      // Create a promise that rejects after the timeout
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error("Upload timeout - server did not respond within the time limit"))
        }, 30000)
      })

      const uploadPromise = this.props.actionUploadFile(
        file,
        varClientId,
        varDivisionId,
        varSenderId,
        varSenderWord,
        filetype,
      )

      const response = await Promise.race([uploadPromise, timeoutPromise])

      if (response.get("success")) {
        // Update file status to success
        this.setState((prevState) => {
          const currentFiles = prevState.files.toJS()
          if (fileIndex !== -1) {
            currentFiles[fileIndex] = {
              ...currentFiles[fileIndex],
              status: "success",
              progress: 100,
            }
          }

          let newForm = prevState.form
          newForm = newForm.set("file-name", response.get("file-name"))
          newForm = newForm.set("upload-completed", true)

          return {
            files: fromJS(currentFiles),
            form: newForm,
          }
        })

        toast.success("Upload Success", { position: toast.POSITION.TOP_RIGHT })
        return { fileId, success: true }
      } else {
        // Update file status to error
        this.setState((prevState) => {
          const currentFiles = prevState.files.toJS()
          if (fileIndex !== -1) {
            currentFiles[fileIndex] = {
              ...currentFiles[fileIndex],
              status: "error",
              progress: 100,
              errorMessage: "Upload failed",
            }
          }
          return { files: fromJS(currentFiles) }
        })

        toast.error("Upload Failed!", { position: toast.POSITION.TOP_RIGHT })
        return { fileId, success: false }
      }
    } catch (error) {
       // Update file status to error
       this.setState((prevState) => {
        const currentFiles = prevState.files.toJS()
        const fileIndex = currentFiles.findIndex((f) => f.id === fileId)

        if (fileIndex !== -1) {
          currentFiles[fileIndex] = {
            ...currentFiles[fileIndex],
            status: "error",
            progress: 100,
            errorMessage: error.message || "Upload failed",
          }
        }

        return { files: fromJS(currentFiles) }
      })

      toast.error("Upload Failed: " + (error.message || "Unknown error"), { position: toast.POSITION.TOP_RIGHT })
      return { fileId, success: false }
    }
  }

  // Upload the next file in the queue
  async uploadNextFile() {
    const files = this.state.files.toJS()

    // Find the next file to upload
    const nextIndex = this.state.currentUploadIndex + 1

    // Find the actual file index in the files array
    let fileIndex = -1
    let fileToUpload = null

    for (let i = 0; i < files.length; i++) {
      if (
        files[i].selected &&
        !(files[i].status && files[i].status.includes("success"))&&
        !(files[i].status && files[i].status.includes("error"))&&
        files[i].status !== "uploading"
      ) {
        if (fileIndex === -1) {
          fileIndex = i
          fileToUpload = files[i]
        }
      }
    }

    if (fileToUpload) {
      // Update the current upload index
      this.setState({
        currentUploadIndex: nextIndex,
      })

      // Update file status to uploading
      this.setState((prevState) => {
        const currentFiles = prevState.files.toJS()
        currentFiles[fileIndex] = {
          ...currentFiles[fileIndex],
          status: "uploading",
          progress: 0,
        }

        return { 
          files: fromJS(currentFiles),
          uploading: true,
        }
      })

      // const shouldFail = fileIndex === 1
      await this.simulateFileUpload(fileToUpload.id, false)

      // Check if there are more files to upload
      const remainingFiles = this.state.files
        .toJS()
        .filter(
          (f) =>
            f.selected && !(f.status && f.status.includes("success")) && !(f.status && f.status.includes("error")) && f.status !== "uploading",
        )

      if (remainingFiles.length > 0) {
        // Upload the next file
        this.uploadNextFile()
      } else {
        // All files have been processed
        this.setState({ uploading: false })
      }
    } else {
      // No more files to upload
      this.setState({ uploading: false })
    }
  }

  // Handle uploading a single file
  async handleUploadSingleFile(index) {
    const files = this.state.files.toJS()
    const fileToUpload = files[index]

    if (!fileToUpload || !fileToUpload.selected) {
      alert("Please select a file to upload")
      return
    }

    // Update file status to uploading
    this.setState((prevState) => {
      const currentFiles = prevState.files.toJS()
      currentFiles[index] = {
        ...currentFiles[index],
        status: "uploading",
        progress: 0,
      }

      return {
        files: fromJS(currentFiles),
        uploading: true,
      }
    })

    await this.simulateFileUpload(fileToUpload.id, false).then(() => {
      // Check if all files are done uploading
      const allDone = this.state.files
        .toJS()
        .every((f) => !f.selected || !f.status || f.status === "success" || f.status === "error")

      if (allDone) {
        this.setState({ uploading: false })
      }
    })
  }

  // Handle retrying a failed upload
  async handleRetryUpload(index) {
    const files = this.state.files.toJS()
    const fileToRetry = files[index]

    if (!fileToRetry || !fileToRetry.selected) {
      return
    }

    // Update file status to uploading
    this.setState((prevState) => {
      const currentFiles = prevState.files.toJS()
      currentFiles[index] = {
        ...currentFiles[index],
        status: "uploading",
        progress: 0,
        errorMessage: "",
      }

      return {
        files: fromJS(currentFiles),
        uploading: true,
      }
    })

    // Simulate file upload (this time let it succeed)
    await this.simulateFileUpload(fileToRetry.id, false).then(() => {
      // Check if all files are done uploading
      const allDone = this.state.files
        .toJS()
        .every((f) => !f.selected || !f.status || f.status === "success" || f.status === "error")

      if (allDone) {
        this.setState({ uploading: false })
      }
    })
  }

  render() {
    const { form, errors, uploading, preparing } = this.state;
    let disable = ''
    if (this.state.disrest == true) {
      disable = this.state.disrest
    } else {
      disable = this.state.disabledHead
    }
    const files = this.state.files.toJS();
    const isDisabled = uploading || preparing
    return (

      <div className="clearfix">
        <div className="card">
          <div className="body clearfix">
            <div className="form-group">
              <span className="col-sm-2">Client</span>
              <div className="col-sm-10">
                <ComboboxInput
                  field='client-id'
                  value={form.get('client-id')}
                  options={fromJS({
                    'source': this.props.Clientall,
                    'value': 'client-id',
                    'label': 'client-name'
                  })}
                  onChange={(field, value, label) => this.handleChange(field, value, label)}
                  placeholder="Client"
                //  disabled={disable}
                  hasError={errors.has('client-id')}
                />
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2">Division</span>
              <div className="col-sm-10">
                <ComboboxInput
                  field='division-id'
                  value={form.get('division-id')}
                  options={fromJS({
                    'source': this.props.Divisionall,
                    'value': 'division-id',
                    'label': 'division-name'
                  })}
                  onChange={(field, value, label) => this.handleChange(field, value, label)}
                  placeholder="Division"
                // disabled={disable}
                />
              </div>
            </div>
            <div className="form-group">
              <span className="col-sm-2">Sender</span>
              <div className="col-sm-10">
                <ComboboxInput
                  field='sender-id'
                  value={form.get('sender-id')}
                  options={fromJS({
                    'source': this.props.Senders,
                    'value': 'sender-id',
                    'label': 'sender-name'
                  })}
                  onChange={(field, value, label) => this.handleChange(field, value, label)}
                  placeholder="Sender"
                  //disabled={disable}
                />
              </div>
            </div>
            <div className="form-group">
              <span className="col-sm-2">File Upload</span>
              <div className="col-sm-10">
                {files.map((file, index) => (
                  <div key={file.id} className="row" style={{ marginBottom: "0px" }}>
                    {/* Always render the file input, but keep it hidden */}
                    <input
                      type="file"
                      ref={this.fileInputRefs[index]}
                      onChange={(e) => this.handleOnFileChanged(e, index)}
                      style={{ display: "none" }}
                      disabled={isDisabled}
                    />

                    {!file.status || file.status === "empty" || file.status === "selected" ? (
                      <div className="col-sm-12" style={{ marginBottom: "0px" }}>
                        <div className="input-group">
                          <span className="input-group-btn">
                            <button
                              type="button"
                              className="btn btn-default"
                              onClick={() => this.handleChooseFile(index)}
                              disabled={isDisabled}
                            >
                              Choose File
                            </button>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            value={file.selected ? file.name : "No file chosen"}
                            readOnly
                            style={{ zIndex: "unset" }}
                          />
                          <span className="input-group-btn">
                            {/* {file.selected && (
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => this.handleUploadSingleFile(index)}
                                disabled={isDisabled}
                              >
                                Upload
                              </button>
                            )} */}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className="col-sm-12" style={{ marginBottom: "0px" }}>
                        <div className="row">
                          <div className="col-sm-2" style={{ marginBottom: "0px" }}>
                            <span>Choose File</span>
                          </div>
                          <div className="col-sm-7" style={{ marginBottom: "0px" }}>
                            <div className="progress">
                              <div
                                className={`progress-bar ${file.status === "error" ? "progress-bar-danger" : "progress-bar-info"}`}
                                role="progressbar"
                                aria-valuenow={file.progress}
                                aria-valuemin="0"
                                aria-valuemax="100"
                                style={{ width: `${file.progress}%` }}
                              >
                                {file.status === "error" ? (
                                  <span>{file.errorMessage}</span>
                                ) : (
                                  file.progress === 100 && <span>{file.progress}%</span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-3 text-center" style={{ marginBottom: "0px" }}>
                            {file.status === "success" && (
                              <i className="material-icons text-success">check</i>
                            )}
                            {file.status === "error" && (
                              <>  
                                <button
                                  type="button"
                                  className="btn btn-warning btn-sm"
                                  onClick={() => this.handleChooseFile(index)}
                                  disabled={isDisabled}
                                  style={{ marginLeft: "10px" }}
                                >
                                  Choose File
                                </button>
                              </>
                            )}
                            {file.status === "uploading" && (
                              <span className="glyphicon glyphicon-refresh glyphicon-spin text-info"></span>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="form-group">
              <span className="col-sm-2"></span>
              <div className="col-sm-10">
                <button type="button"
                  className="btn btn-info"
                  disabled={this.state.disabled || isDisabled}
                  onClick={this.handleUploadFile}>
                  Upload
                </button>
              </div>
            </div>
            <div className="form-group">
              <span className="col-sm-2"></span>
              <div className="col-sm-6">
                <button type="button"
                  className="btn btn-width btn-danger"
                  value="Cancel"
                  onClick={this.handleCancel}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }



}


export default connect(
  (state) => {
    return {
      Clientall: state.user.clientall,
      Divisionall: state.user.divisionall,
      Senders: state.user.senders,
      accessmodules: state.user.accessmodules,
    }
  },
  dispatch => bindActionCreators({
    actionFetchAllClient: ActionFetchAllClient,
    actionFetchAllDivision: ActionFetchAllDivision,
    actionFetchSender: ActionFetchSender,
    actionGetAccessModule: ActionGetAccessModule,
    actionUploadFile: UploadFile
  }, dispatch),
)(Form);